import { SET_MANUAL_ENTRY_EDIT_DATA, CLEAR_MANUAL_ENTRY_EDIT_DATA, SET_MANUAL_ENTRY_ADD_DATA, CLEAR_MANUAL_ENTRY_ADD_DATA } from './actionTypes';

import ManualEntryEdit from '../../models/ManualEntryEdit';
import ManualEntryAdd from '../../models/ManualEntryAdd';

function entryEditAddData(manualEntryEdit: ManualEntryEdit) {
  return {
    type: SET_MANUAL_ENTRY_EDIT_DATA,
    data: manualEntryEdit
  };
};

function entryAddData(manualEntryEdit: ManualEntryAdd) {
  return {
    type: SET_MANUAL_ENTRY_ADD_DATA,
    data: manualEntryEdit
  };
};

function entryEditClearData() {
  return {
    type: CLEAR_MANUAL_ENTRY_EDIT_DATA
  };
};

function entryAddClearData() {
  return {
    type: CLEAR_MANUAL_ENTRY_ADD_DATA
  };
};

export {
  entryEditAddData,
  entryEditClearData,
  entryAddData,
  entryAddClearData
};
